<template>
  <div class="page-tea">
    <div class="cont-pc">
      <div class="pc-banner"></div>
      <div class="pc-cont">
        <img class="pc-img" src="@/assets/images/tea_pc_cont.jpg" />
      </div>
    </div>
    <img class="cont-m" src="@/assets/images/tea_m_cont.jpg" alt="" />

    <div class="buy-wrap">
      <div class="buy-cont">
        <div class="des-price">
          <span class="des">单价（包邮）：</span>
          <span class="price">￥998.00</span>
        </div>
        <div class="btn" @click="toBuy">立即购买</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tea',
    methods: {
      toBuy () {
        this.$router.push('/tea/buy')
      }
    }
  }
</script>

<style lang="less" scoped>
.page-tea {
  padding-top: @NAVHEIGHT;
  padding-bottom: 10px;
  background: #fff;

  .cont-pc {
    display: none;

    .pc-banner {
       width: 100%;
       height: 486px;
       background-image: url('../../assets/images/tea_pc_banner.jpg');
       background-position: center;
       background-repeat: no-repeat;
       background-color: #f3f2f7;
    }

    .pc-cont {
      display: block;

      .pc-img {
        display: block;
        margin: 0 auto;
      }
    }
  }

  .cont-m {
    display: block;
    width: 100%;
  }

  .buy-wrap {
    position: fixed;
    z-index: 1;
    bottom: 0;
    width: 100%;
    height: 40px;
    background: #f5f5f5;

    .buy-cont {
      display: flex;
      justify-content: space-between;
      width: 100%;
      line-height: 40px;

      .des-price {
        padding-left: 15px;
        color: #ec3935;

        .des {
          font-size: 12px;
        }
        .price {
          font-size: 16px;
          font-weight: bold;
        }
      }

      .btn {
        width: 112px;
        height: 40px;
        text-align: center;
        color: #fff;
        font-size: 14px;
        background: #ec3935;
        cursor: pointer;
      }
    }
  }
}
@media screen and (min-width: 750px) {
  .page-tea {
    padding-bottom: 20px;
    
    .buy-wrap {
      height: 80px;

      .buy-cont {
        line-height: 80px;
        padding-right: 85px;


        .des-price {
          padding-left: 30px;

          .des {
            font-size: 24px;
          }
          .price {
            font-size: 32px;
          }
        }

        .btn {
          width: 224px;
          height: 80px;
          font-size: 28px;
        }
        
      }
    }
  }
}
@media screen and (min-width: 1080px) {
  .page-tea {
    .cont-pc {
      display: block;
    }

    .cont-m {
      display: none;
    }

    .buy-wrap {
      .buy-cont {
        justify-content: flex-end;
        width: 1080px;
        margin: 0 auto;
        padding-right: 0;

        .des-price {
          padding-left: 0;
          padding-right: 110px;
        }
      }
    }
  }
}
</style>
